var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4991 36.0208C10.4824 36.0208 3.97656 29.3233 3.97656 21.1058C3.97656 12.8883 10.4824 6.17499 18.4991 6.17499C20.1486 6.17499 21.752 6.41249 23.2936 6.90332C23.9103 7.09332 24.2495 7.75832 24.0645 8.39165C23.8795 9.02499 23.232 9.37332 22.6153 9.18332C21.3049 8.77165 19.9174 8.54999 18.4991 8.54999C11.762 8.54999 6.28906 14.1708 6.28906 21.09C6.28906 28.0092 11.762 33.63 18.4991 33.63C25.2361 33.63 30.7091 28.0092 30.7091 21.09C30.7091 18.5883 29.9999 16.1817 28.6586 14.1233C28.3041 13.585 28.4428 12.8408 28.9824 12.4767C29.5066 12.1125 30.2311 12.255 30.5857 12.8092C32.1891 15.2633 33.037 18.1292 33.037 21.1058C33.0216 29.3233 26.5157 36.0208 18.4991 36.0208Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.868 9.61084C24.5443 9.61084 24.2205 9.46834 23.9893 9.19917L19.5338 3.9425C19.1176 3.45167 19.1638 2.69167 19.6418 2.26417C20.1197 1.83667 20.8597 1.88417 21.2759 2.375L25.7313 7.63167C26.1476 8.12251 26.1013 8.8825 25.6234 9.31C25.423 9.51584 25.1455 9.61084 24.868 9.61084Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6717 13.5058C19.3171 13.5058 18.9625 13.3316 18.7313 13.015C18.3613 12.4925 18.4692 11.7483 18.9779 11.3525L24.1733 7.45747C24.6821 7.06164 25.4067 7.1883 25.7921 7.7108C26.1775 8.2333 26.0542 8.97747 25.5454 9.3733L20.35 13.2841C20.1496 13.4425 19.9183 13.5058 19.6717 13.5058Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.6fe7ca796ea53a8f063c7646b6c42fc9.svg";
export { ForwardRef as ReactComponent };